import { FetchInstance } from "@/api/FetchInstance";
import type { UserProfile } from "@/hooks/queries/useUser";
import type { IResponse } from "@/types";

const STORAGE_KEY = "pending_event_registration";

export function savePendingEventRegistration(eventId: number) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ eventId }));
}

/** Token bor bo'lgach, saqlangan tadbirga yozilish so'rovini yuboradi. */
export async function resumePendingEventRegistration(): Promise<boolean> {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return false;

  let eventId: number | undefined;
  try {
    eventId = JSON.parse(raw)?.eventId;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return false;
  }
  if (!eventId) {
    sessionStorage.removeItem(STORAGE_KEY);
    return false;
  }

  const profile = await FetchInstance<IResponse<UserProfile>>("/api/v1.0/user/me", {
    method: "POST",
  });
  const phoneOrEmail = profile?.data?.phone || profile?.data?.email;
  if (!profile?.success || !phoneOrEmail) return false;

  const response = await FetchInstance<IResponse<unknown>>(
    "/api/v1.0/user/event/store",
    {
      method: "POST",
      body: JSON.stringify({
        event_id: eventId,
        phone_or_email: phoneOrEmail,
      }),
    }
  );

  if (response?.success) {
    sessionStorage.removeItem(STORAGE_KEY);
    return true;
  }
  return false;
}
